module.exports = __webpack_public_path__ + "img/GRANALLADORA.6afab898.jpg";